import {
    ChangeDetectorRef,
    Component,
    ComponentRef,
    effect,
    Inject,
    OnDestroy,
    viewChild,
    ViewContainerRef,
} from '@angular/core';
import { ModalWindowSize } from '@se/platform';
import { DataBinding, Logger, SeConstraintNotifierService } from '@se/se.platform.base';
import { Subscription } from 'rxjs';

import { CpUserControl, ICpEntity } from '../../cp-configuration/view-model';
import { CpModelService } from '../../cp-model.service';
import { IUserControlResolver, UserControlResolver } from '../../user-control-resolver';
import { AbstractControlComponent } from '../abstract-control';

@Component({
    selector: 'cp-user-control',
    templateUrl: './user-control.component.html',
    styleUrls: ['./user-control.component.scss'],
    standalone: false,
})
export class CpUserControlComponent extends AbstractControlComponent implements OnDestroy {
    containerRef = viewChild('userControl', { read: ViewContainerRef });

    control!: CpUserControl;

    private _dataRootValue!: any;
    private subscribedComponent: Subscription | undefined;
    private subscribedWarning: Subscription | undefined;
    private component?: ComponentRef<any>;

    get dataRoot(): ICpEntity {
        return this._dataRootValue;
    }

    constructor(
        public changeDetectorRef: ChangeDetectorRef,
        private modelService: CpModelService,
        constraintNotifierService: SeConstraintNotifierService,
        @Inject(UserControlResolver) private userControlService: IUserControlResolver,
        logger: Logger,
    ) {
        super(changeDetectorRef, constraintNotifierService, logger);
        effect(() => {
            const containerRef = this.containerRef();
            if (containerRef) this.loadUserControl(containerRef);
        });
    }

    getSize() {
        switch (this.control?.idUserControl) {
            case 'idExampleUserControl':
                return ModalWindowSize.small;
            case 'idUserControlMeasureDetails':
            case 'idUserControlEcgData':
                return ModalWindowSize.fullScreen;
            case 'idUserControlDDeviceViewer':
                return ModalWindowSize.medium;
            default:
                return ModalWindowSize.medium;
        }
    }

    onEdited() {
        this.edited.emit();
    }

    private async loadUserControl(container: ViewContainerRef) {
        this.component = await this.userControlService.loadComponent(container, this.control?.idUserControl);
        this.component.instance.dataRoot = this.dataRoot;
        this.component.instance.cardId = this.cardId;
        this.component.instance.form = this.form;
        this.component.instance.control = this.control;
        this.component.instance.isDisabled = this.isDisabled;
        this.component.instance.isHidden = this.isHidden;
        this.component.instance.containerInfo = this.containerInfo;

        this.subscribedWarning = this.component.instance.warningChanged?.subscribe((warning: string) => {
            this.warningMessage = warning;
            //this.warningChanged.emit(warning);
        });

        this.subscribedComponent = this.component.instance.edited?.subscribe(() => {
            this.onEdited();
        });
        this.component.changeDetectorRef.detectChanges();
    }

    protected init() {
        this.dataBind();
    }

    protected onModelChange(_: unknown): boolean {
        return true;
    }

    protected handleHiddenNotification(isHidden: boolean) {
        if (this.component) {
            this.component.instance.isHidden = isHidden;
        }
    }

    protected handleDisabledNotification(isDisabled: boolean) {
        if (this.component) {
            this.component.instance.isDisabled = isDisabled;
        }
    }

    protected updateFormControl() {
        if (this.component) {
            this.component.instance.isDisabled = this.isDisabled;
        }

        if (!this.form) {
            return;
        }

        if (this.isDisabled !== this.form.disabled) {
            this.isDisabled ? this.form.disable() : this.form.enable();
        }
    }

    private dataBind() {
        this._dataRootValue = this.modelService.getEntity(new DataBinding());
    }

    ngOnDestroy() {
        this.subscribedComponent?.unsubscribe();
        this.subscribedWarning?.unsubscribe();
    }
}
